export const EXPIRED_BONUS_LIST_STATUS = ["CANCELED", "EXPIRED", "RELEASED"];